<div class="full-page-container">
  <fgb-banner [title]="'terms.page.title' | translate"></fgb-banner>

  <fgb-page-header
    [pageTitle]="'terms.page.title'"
    [backButtonLink]="'/'"
    [showBalance]="false"
    [showQr]="false"
  ></fgb-page-header>

  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="term-box">
          <fgbcl-terms-and-conditions [type]="termsAndConditionsType"></fgbcl-terms-and-conditions>
        </div>
      </div>
    </div>
  </div>
</div>
